import React from 'react';
import PropTypes from 'prop-types';

function TableHeading({ children, className }) {
  return (
    <th
      className={`px-6 py-3 text-xs font-medium leading-4 tracking-wider text-white uppercase bg-light-pink ${
        className || ''
      }`}
    >
      {children}
    </th>
  );
}

TableHeading.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export { TableHeading };
